import SectionPage from '../components/SectionPage';

export default function Nosotros() {
  return (
    <SectionPage
      title="Nosotros"
      intro="RECYCLA Chile es un emprendimiento social que busca transformaciones innovadoras y financieramente sostenibles para resolver problemas ambientales y sociales."
      sections={[
        {
          title: 'Política Ambiental',
          id: 'politica-ambiental',
          body: <p>Compromiso con el desarrollo sustentable, la mejora continua y el cumplimiento ambiental.</p>,
        },
        {
          title: 'Espíritu',
          id: 'espiritu',
          body: <p>Un emprendimiento social que busca cambio social a través de innovación, enfoque diferente y tecnologías conocidas.</p>,
        },
        {
          title: 'Historia',
          id: 'historia',
          body: <p>Recycla nace para contribuir a la responsabilidad social de las empresas mediante reciclaje y programas laborales de reinserción.</p>,
        },
        {
          title: 'Resoluciones',
          id: 'resoluciones',
          body: <p>Documentación y hitos institucionales asociados al crecimiento de la organización.</p>,
        },
        {
          title: 'Premios',
          id: 'premios',
          body: <p>Reconocimientos al liderazgo ambiental y al emprendimiento social.</p>,
        },
        {
          title: 'Aliados',
          id: 'aliados',
          body: <p>Trabajo en red con empresas, instituciones y organizaciones para amplificar el impacto.</p>,
        },
      ]}
    />
  );
}
